/* Guías de orden en la bandeja. Ver el contrato de campos en ../guides.js */

export const GUIDES_INBOX = [
  {
    slug: 'find-an-email',
    id: 'search',
    category: 'inbox',
    icon: 'search',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'buscar', 'cercar', 'search', 'find email', 'no encuentro un correo', 'no trobo un correu',
      'buscador', 'cercador', 'encontrar', 'trobar', 'dónde está aquel correo', 'búsqueda',
      'buscar por significado', 'buscar dentro de pdf',
    ],
    ca: {
      title: 'Trobar un correu del qual només recordes mitja frase',
      lead: 'No cal encertar la paraula exacta: pots buscar pel sentit del que deia.',
      answer:
        'Prem el cercador a dalt de la llista (o ⌘/Ctrl + F) i escriu el que recordis, encara que sigui aproximat: “el pressupost de la caldera”. Nukli busca per paraules i pel significat alhora, i també dins dels PDF rebuts.',
      steps: [
        {
          t: 'Obre el cercador',
          d: 'La caixa de dalt de la llista de correus. Amb el teclat: ⌘ + F al Mac, Ctrl + F a Windows.',
          screen: 'inbox',
          highlight: 'search',
        },
        {
          t: 'Escriu com et surti',
          d: '“La factura de la llum de l’any passat”, “el senyor que venia finestres”. No cal la paraula exacta ni el nom ben escrit.',
          screen: 'inbox',
          highlight: 'search',
        },
        {
          t: 'Ordena els resultats',
          d: 'Pots veure’ls per rellevància (el que més s’assembla al que busques) o pel més recent.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'O demana-ho al xat',
          d: 'Si prefereixes explicar-ho amb una frase: “busca’m el correu on em passaven el pressupost de la caldera”.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'Les cerques recents es guarden i les pots repetir amb un clic (i esborrar-les quan vulguis).',
        'Si el que busques era un adjunt, prova amb el que hi havia escrit a dins: Nukli també mira dins dels PDF.',
      ],
      faq: [
        {
          q: 'Busca en tots els comptes?',
          a: 'Busca a la vista on ets. Si vols buscar-ho tot, posa’t a “Totes les safates” abans.',
        },
        {
          q: 'No em surt un correu que sé que tinc',
          a: 'Potser encara no s’ha acabat de baixar del servidor. Prova al cap d’una estona o fes servir el botó de sincronitzar.',
        },
      ],
    },
    es: {
      title: 'Encontrar un correo del que solo recuerdas media frase',
      lead: 'No hace falta acertar la palabra exacta: puedes buscar por el sentido de lo que decía.',
      answer:
        'Pulsa el buscador de arriba de la lista (o ⌘/Ctrl + F) y escribe lo que recuerdes, aunque sea aproximado: “el presupuesto de la caldera”. Nukli busca por palabras y por significado a la vez, y también dentro de los PDF recibidos.',
      steps: [
        {
          t: 'Abre el buscador',
          d: 'La caja de arriba de la lista de correos. Con el teclado: ⌘ + F en Mac, Ctrl + F en Windows.',
          screen: 'inbox',
          highlight: 'search',
        },
        {
          t: 'Escribe como te salga',
          d: '“La factura de la luz del año pasado”, “el señor que vendía ventanas”. No hace falta la palabra exacta ni el nombre bien escrito.',
          screen: 'inbox',
          highlight: 'search',
        },
        {
          t: 'Ordena los resultados',
          d: 'Puedes verlos por relevancia (lo que más se parece a lo que buscas) o por lo más reciente.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'O pídelo en el chat',
          d: 'Si prefieres explicarlo con una frase: “búscame el correo donde me pasaban el presupuesto de la caldera”.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'Las búsquedas recientes se guardan y las puedes repetir con un clic (y borrarlas cuando quieras).',
        'Si lo que buscas era un adjunto, prueba con lo que ponía dentro: Nukli también mira dentro de los PDF.',
      ],
      faq: [
        {
          q: '¿Busca en todas las cuentas?',
          a: 'Busca en la vista donde estés. Si quieres buscarlo todo, ponte antes en “Todas las bandejas”.',
        },
        {
          q: 'No me sale un correo que sé que tengo',
          a: 'Puede que aún no haya terminado de bajar del servidor. Prueba dentro de un rato o usa el botón de sincronizar.',
        },
      ],
    },
    en: {
      title: 'Finding an email when you only remember half a sentence',
      lead: 'You do not need the exact word: you can search by what the message was about.',
      answer:
        'Press the search box above the list (or ⌘/Ctrl + F) and type whatever you remember, even roughly: “the boiler quote”. Nukli searches by words and by meaning at the same time, and inside received PDFs too.',
      steps: [
        {
          t: 'Open search',
          d: 'The box above the email list. On the keyboard: ⌘ + F on Mac, Ctrl + F on Windows.',
          screen: 'inbox',
          highlight: 'search',
        },
        {
          t: 'Type it however it comes out',
          d: '“Last year’s electricity bill”, “the man selling windows”. No need for the exact word or the correct spelling of a name.',
          screen: 'inbox',
          highlight: 'search',
        },
        {
          t: 'Sort the results',
          d: 'You can see them by relevance (closest to what you asked) or by most recent.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Or ask in the chat',
          d: 'If you would rather describe it in a sentence: “find the email with the boiler quote”.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'Recent searches are kept and you can repeat one with a click (or delete them whenever you like).',
        'If what you want was an attachment, try the words that were inside it: Nukli looks in PDFs too.',
      ],
      faq: [
        {
          q: 'Does it search every account?',
          a: 'It searches the view you are in. To search everything, switch to “All inboxes” first.',
        },
        {
          q: 'An email I know I have does not show up',
          a: 'It may not have finished downloading from the server yet. Try again shortly or use the sync button.',
        },
      ],
    },
  },

  {
    slug: 'follow-ups',
    id: 'follow-ups',
    category: 'inbox',
    icon: 'clock-alert',
    level: 'basic',
    plan: 'free',
    minutes: 4,
    topics: [
      'seguiments', 'seguimientos', 'follow-ups', 'follow ups', 'pendientes', 'pendents',
      'me olvido de contestar', 'se me escapan correos', 'qué tengo pendiente', 'què tinc pendent',
      'sin responder', 'unanswered',
    ],
    ca: {
      title: 'Seguiments: que no se t’escapi cap resposta',
      lead: 'Nukli repassa els teus correus i et fa una llista dels que encara esperen alguna cosa de tu.',
      answer:
        'A la llista de correus hi ha la pestanya “Pendents”: són els correus rebuts que encara esperen resposta teva, amb el motiu i què hauries de contestar. Quan un el donis per fet, marca’l com a fet i marxa de la llista.',
      steps: [
        {
          t: 'Obre la pestanya “Pendents”',
          d: 'A dalt de la llista de correus, al costat de “Tots”. Hi surt el nombre de correus que t’esperen.',
          screen: 'followups',
          highlight: 'tabs',
        },
        {
          t: 'Mira per què és pendent',
          d: 'Cada fila diu qui espera, des de quan, com d’urgent és i què et recomana fer. No te l’has d’estudiar: es llegeix d’un cop d’ull.',
          screen: 'followups',
          highlight: 'list',
        },
        {
          t: 'Contesta’ls d’un en un',
          d: 'Obre’l i respon com sempre (amb IA si vols). En respondre, normalment ja surt de pendents.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Marca com a fet el que no cal contestar',
          d: 'Si un correu ja està resolt per telèfon o no cal fer-hi res, marca’l com a fet i desapareix de la llista.',
          screen: 'followups',
          highlight: 'list',
        },
        {
          t: 'Pregunta-ho al xat quan vulguis',
          d: '“Què tinc pendent?” o “què hauria de contestar avui?”: te’n fa el repàs sense sortir de l’assistent.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'Dels correus que envies tu no se’n fa seguiment: aquí només hi surt el que has rebut.',
        'El pla gratuït mira els últims dies; els plans de pagament arriben més enrere.',
      ],
      faq: [
        {
          q: 'Puc marcar jo un correu com a pendent?',
          a: 'Sí. Amb el botó dret sobre la fila de la llista, tria “Marca per fer seguiment”.',
        },
        {
          q: 'Em surt buit',
          a: 'O bé estàs al dia, o encara no ha acabat l’anàlisi. Prem “Actualitza els seguiments” i espera una mica.',
        },
      ],
    },
    es: {
      title: 'Seguimientos: que no se te escape ninguna respuesta',
      lead: 'Nukli repasa tus correos y te hace una lista de los que todavía esperan algo de ti.',
      answer:
        'En la lista de correos está la pestaña “Pendientes”: son los correos recibidos que aún esperan respuesta tuya, con el motivo y qué deberías contestar. Cuando des uno por hecho, márcalo como hecho y sale de la lista.',
      steps: [
        {
          t: 'Abre la pestaña “Pendientes”',
          d: 'Arriba de la lista de correos, al lado de “Todos”. Sale el número de correos que te esperan.',
          screen: 'followups',
          highlight: 'tabs',
        },
        {
          t: 'Mira por qué está pendiente',
          d: 'Cada fila dice quién espera, desde cuándo, cuánto urge y qué te recomienda hacer. No hay que estudiárselo: se lee de un vistazo.',
          screen: 'followups',
          highlight: 'list',
        },
        {
          t: 'Contéstalos uno a uno',
          d: 'Ábrelo y responde como siempre (con IA si quieres). Al responder, normalmente ya sale de pendientes.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Marca como hecho lo que no hay que contestar',
          d: 'Si un correo ya está resuelto por teléfono o no requiere nada, márcalo como hecho y desaparece de la lista.',
          screen: 'followups',
          highlight: 'list',
        },
        {
          t: 'Pregúntalo en el chat cuando quieras',
          d: '“¿Qué tengo pendiente?” o “¿qué debería contestar hoy?”: te hace el repaso sin salir del asistente.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'De los correos que envías tú no se hace seguimiento: aquí solo sale lo que has recibido.',
        'El plan gratuito mira los últimos días; los planes de pago llegan más atrás.',
      ],
      faq: [
        {
          q: '¿Puedo marcar yo un correo como pendiente?',
          a: 'Sí. Con el botón derecho sobre la fila de la lista, elige “Marcar para seguimiento”.',
        },
        {
          q: 'Me sale vacío',
          a: 'O estás al día, o el análisis aún no ha terminado. Pulsa “Actualizar seguimientos” y espera un poco.',
        },
      ],
    },
    en: {
      title: 'Follow-ups: so no reply slips away',
      lead: 'Nukli goes through your mail and lists the messages still waiting on you.',
      answer:
        'The email list has a “Pending” tab: received emails that are still waiting for your answer, with the reason and a suggested next step. Once you consider one done, mark it as done and it leaves the list.',
      steps: [
        {
          t: 'Open the “Pending” tab',
          d: 'At the top of the email list, next to “All”. It shows how many emails are waiting.',
          screen: 'followups',
          highlight: 'tabs',
        },
        {
          t: 'See why it is pending',
          d: 'Each row tells you who is waiting, since when, how urgent it is and what it suggests you do. It reads at a glance.',
          screen: 'followups',
          highlight: 'list',
        },
        {
          t: 'Answer them one by one',
          d: 'Open it and reply as usual (with AI if you like). Replying normally takes it off the pending list.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Mark as done anything that needs no reply',
          d: 'If it was sorted out by phone or needs nothing, mark it done and it disappears from the list.',
          screen: 'followups',
          highlight: 'list',
        },
        {
          t: 'Ask in the chat any time',
          d: '“What is still pending?” or “what should I answer today?”: you get the round-up without leaving the assistant.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'Emails you send are not followed up: this list is only about what you received.',
        'The free plan looks at the last few days; paid plans go further back.',
      ],
      faq: [
        {
          q: 'Can I mark an email as pending myself?',
          a: 'Yes. Right-click the row in the list and choose “Mark for follow-up”.',
        },
        {
          q: 'Mine is empty',
          a: 'Either you are up to date, or the analysis has not finished. Press “Refresh follow-ups” and wait a moment.',
        },
      ],
    },
  },

  {
    slug: 'folder-groups',
    id: 'folder-groups',
    category: 'inbox',
    icon: 'folders',
    level: 'medium',
    plan: 'free',
    minutes: 3,
    topics: [
      'grups de carpetes', 'grupos de carpetas', 'folder groups', 'ordenar carpetas', 'barra lateral',
      'sidebar', 'muchas carpetas', 'moltes carpetes', 'organizar buzones', 'lío de carpetas',
    ],
    ca: {
      title: 'Ordenar la barra lateral amb grups de carpetes',
      lead: 'Quaranta carpetes escampades entre tres comptes es poden veure com quatre calaixos.',
      answer:
        'Nukli pot agrupar les teves carpetes en calaixos temàtics (Feina, Compres, Família…) a la columna de bústies. És només una manera de mirar-s’ho: els correus no es mouen mai de la seva carpeta de veritat.',
      steps: [
        {
          t: 'Obre la columna de bústies',
          d: 'Primer botó de la barra d’icones. Si tens moltes carpetes, aquí és on es nota el desordre.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Deixa que proposi els grups',
          d: 'Nukli mira els noms de les teves carpetes i proposa calaixos amb sentit. Els revises i els acceptes.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Obre un calaix',
          d: 'En prémer un grup veuràs els correus de totes les carpetes que conté, juntes.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Canvia’l quan vulguis',
          d: 'Els grups es poden reanomenar i refer. No hi ha res irreversible perquè no s’ha mogut cap correu.',
        },
      ],
      tips: [
        'És especialment útil si tens el correu de la feina amb carpetes per client i el personal amb carpetes per any.',
        'Si prefereixes la vista de sempre, no facis grups: la columna funciona igual.',
      ],
      faq: [
        {
          q: 'Es mouran els meus correus?',
          a: 'No. Els grups només uneixen el que ensenya la pantalla; al servidor tot es queda on estava.',
        },
      ],
    },
    es: {
      title: 'Ordenar la barra lateral con grupos de carpetas',
      lead: 'Cuarenta carpetas repartidas entre tres cuentas se pueden ver como cuatro cajones.',
      answer:
        'Nukli puede agrupar tus carpetas en cajones temáticos (Trabajo, Compras, Familia…) en la columna de buzones. Es solo una forma de mirarlo: los correos nunca se mueven de su carpeta de verdad.',
      steps: [
        {
          t: 'Abre la columna de buzones',
          d: 'Primer botón de la barra de iconos. Si tienes muchas carpetas, aquí es donde se nota el desorden.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Deja que proponga los grupos',
          d: 'Nukli mira los nombres de tus carpetas y propone cajones con sentido. Los revisas y los aceptas.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Abre un cajón',
          d: 'Al pulsar un grupo verás los correos de todas las carpetas que contiene, juntos.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Cámbialo cuando quieras',
          d: 'Los grupos se pueden renombrar y rehacer. No hay nada irreversible porque no se ha movido ningún correo.',
        },
      ],
      tips: [
        'Es especialmente útil si tienes el correo del trabajo con carpetas por cliente y el personal con carpetas por año.',
        'Si prefieres la vista de siempre, no hagas grupos: la columna funciona igual.',
      ],
      faq: [
        {
          q: '¿Se moverán mis correos?',
          a: 'No. Los grupos solo juntan lo que enseña la pantalla; en el servidor todo se queda donde estaba.',
        },
      ],
    },
    en: {
      title: 'Tidying up the sidebar with folder groups',
      lead: 'Forty folders spread across three accounts can be shown as four drawers.',
      answer:
        'Nukli can group your folders into themed drawers (Work, Shopping, Family…) in the mailboxes column. It is purely a way of looking at things: emails never move out of their real folder.',
      steps: [
        {
          t: 'Open the mailboxes column',
          d: 'First button in the icon bar. If you have many folders, this is where the mess shows.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Let it propose the groups',
          d: 'Nukli reads your folder names and proposes sensible drawers. You review them and accept.',
          screen: 'inbox',
          highlight: 'mailboxes',
        },
        {
          t: 'Open a drawer',
          d: 'Pressing a group shows the emails from all the folders inside it, together.',
          screen: 'inbox',
          highlight: 'list',
        },
        {
          t: 'Change it whenever',
          d: 'Groups can be renamed and rebuilt. Nothing is irreversible, because no email has moved.',
        },
      ],
      tips: [
        'Especially useful if work mail has folders per client and personal mail has folders per year.',
        'If you prefer the plain view, simply do not create groups — the column works as before.',
      ],
      faq: [
        {
          q: 'Will my emails be moved?',
          a: 'No. Groups only join what the screen shows; on the server everything stays put.',
        },
      ],
    },
  },

  {
    slug: 'mail-rules',
    id: 'mail-rules',
    category: 'inbox',
    icon: 'filter',
    level: 'medium',
    plan: 'free',
    minutes: 5,
    topics: [
      'regles', 'reglas', 'rules', 'filtros', 'filtres', 'mover automáticamente', 'moure sol',
      'clasificar correo', 'automatizar', 'automatitzar', 'que se ordene solo', 'etiquetar',
    ],
    ca: {
      title: 'Regles: que el correu s’ordeni sol',
      lead: 'Els extractes del banc a la seva carpeta, els butlletins marcats com a llegits, sense fer-hi res tu.',
      answer:
        'A la barra d’icones hi ha les regles. Una regla diu: “si el correu compleix això, fes això altre”. Per exemple: si el remitent conté “banc”, mou-lo a la carpeta Banc. Les pots aplicar també als correus que ja tens.',
      steps: [
        {
          t: 'Obre les regles',
          d: 'Botó de la barra d’icones de l’esquerra (o Configuració > Regles).',
          screen: 'settings-rules',
          highlight: 'rail',
        },
        {
          t: 'Prem “Afegeix una regla” i posa-li nom',
          d: 'Un nom que entenguis d’aquí a un any: “Extractes del banc a la seva carpeta”.',
          screen: 'settings-rules',
          highlight: 'add',
        },
        {
          t: 'Digues quan s’ha d’aplicar',
          d: 'Tries un camp (remitent, assumpte, contingut…), una condició (conté, és igual a…) i el text. Pots posar-ne diverses i demanar que es compleixin totes o qualsevol.',
          screen: 'rule-editor',
          highlight: 'conditions',
        },
        {
          t: 'Digues què ha de fer',
          d: 'Moure a una carpeta, marcar com a llegit, posar-hi una bandera de color, silenciar o enviar a la paperera.',
          screen: 'rule-editor',
          highlight: 'actions',
        },
        {
          t: 'Aplica-la al que ja tens',
          d: 'El botó “Aplica les regles ara” repassa la safata i ordena els correus antics amb les regles actives.',
          screen: 'settings-rules',
          highlight: 'apply',
        },
      ],
      tips: [
        'Comença per una regla senzilla i mira què fa abans de crear-ne deu.',
        'Si una regla et fa nosa, desactiva-la en comptes d’esborrar-la: podràs tornar-la a engegar.',
      ],
      faq: [
        {
          q: 'S’esborrarà cap correu sense avisar?',
          a: 'Només si tu crees una regla que digui explícitament “mou a la paperera”. Per defecte, cap regla esborra res.',
        },
        {
          q: 'Puc fer regles diferents per a cada compte?',
          a: 'Sí, cada regla es pot limitar a un compte o aplicar-se a tots.',
        },
      ],
    },
    es: {
      title: 'Reglas: que el correo se ordene solo',
      lead: 'Los extractos del banco a su carpeta, los boletines marcados como leídos, sin que tú hagas nada.',
      answer:
        'En la barra de iconos están las reglas. Una regla dice: “si el correo cumple esto, haz esto otro”. Por ejemplo: si el remitente contiene “banco”, muévelo a la carpeta Banco. También se pueden aplicar a los correos que ya tienes.',
      steps: [
        {
          t: 'Abre las reglas',
          d: 'Botón de la barra de iconos de la izquierda (o Ajustes > Reglas).',
          screen: 'settings-rules',
          highlight: 'rail',
        },
        {
          t: 'Pulsa “Añadir regla” y ponle nombre',
          d: 'Un nombre que entiendas dentro de un año: “Extractos del banco a su carpeta”.',
          screen: 'settings-rules',
          highlight: 'add',
        },
        {
          t: 'Di cuándo se tiene que aplicar',
          d: 'Eliges un campo (remitente, asunto, contenido…), una condición (contiene, es igual a…) y el texto. Puedes poner varias y pedir que se cumplan todas o cualquiera.',
          screen: 'rule-editor',
          highlight: 'conditions',
        },
        {
          t: 'Di qué tiene que hacer',
          d: 'Mover a una carpeta, marcar como leído, poner una bandera de color, silenciar o enviar a la papelera.',
          screen: 'rule-editor',
          highlight: 'actions',
        },
        {
          t: 'Aplícala a lo que ya tienes',
          d: 'El botón “Aplicar reglas ahora” repasa la bandeja y ordena los correos antiguos con las reglas activas.',
          screen: 'settings-rules',
          highlight: 'apply',
        },
      ],
      tips: [
        'Empieza por una regla sencilla y mira qué hace antes de crear diez.',
        'Si una regla te estorba, desactívala en vez de borrarla: podrás volver a encenderla.',
      ],
      faq: [
        {
          q: '¿Se borrará algún correo sin avisar?',
          a: 'Solo si tú creas una regla que diga explícitamente “mover a la papelera”. Por defecto ninguna regla borra nada.',
        },
        {
          q: '¿Puedo hacer reglas distintas para cada cuenta?',
          a: 'Sí, cada regla se puede limitar a una cuenta o aplicarse a todas.',
        },
      ],
    },
    en: {
      title: 'Rules: letting the mail sort itself',
      lead: 'Bank statements into their folder, newsletters marked as read, without you lifting a finger.',
      answer:
        'The icon bar has rules. A rule says: “if the email matches this, do that”. For example: if the sender contains “bank”, move it to the Bank folder. You can also apply rules to mail you already have.',
      steps: [
        {
          t: 'Open the rules',
          d: 'Button in the icon bar on the left (or Settings > Rules).',
          screen: 'settings-rules',
          highlight: 'rail',
        },
        {
          t: 'Press “Add rule” and name it',
          d: 'A name you will still understand in a year: “Bank statements to their folder”.',
          screen: 'settings-rules',
          highlight: 'add',
        },
        {
          t: 'Say when it applies',
          d: 'Pick a field (sender, subject, content…), a condition (contains, equals…) and the text. You can add several and require all of them or any of them.',
          screen: 'rule-editor',
          highlight: 'conditions',
        },
        {
          t: 'Say what it should do',
          d: 'Move to a folder, mark as read, add a coloured flag, mute, or move to trash.',
          screen: 'rule-editor',
          highlight: 'actions',
        },
        {
          t: 'Apply it to what you already have',
          d: 'The “Apply rules now” button goes through the inbox and sorts older mail with your active rules.',
          screen: 'settings-rules',
          highlight: 'apply',
        },
      ],
      tips: [
        'Start with one simple rule and watch what it does before creating ten.',
        'If a rule gets in the way, disable it rather than delete it — you can switch it back on.',
      ],
      faq: [
        {
          q: 'Could an email be deleted without warning?',
          a: 'Only if you create a rule that explicitly says “move to trash”. By default no rule deletes anything.',
        },
        {
          q: 'Can I have different rules per account?',
          a: 'Yes, each rule can be limited to one account or applied to all of them.',
        },
      ],
    },
  },

  {
    slug: 'spam-and-junk',
    id: 'spam',
    category: 'inbox',
    icon: 'shield-alert',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'spam', 'correu brossa', 'correo basura', 'publicidad', 'publicitat', 'junk', 'estafa',
      'phishing', 'no quiero recibir', 'bloquear', 'bloquejar', 'me llega mucha basura',
      'darse de baja', 'newsletter',
    ],
    ca: {
      title: 'Treure’t la publicitat i el correu brossa de sobre',
      lead: 'Tres eines: el filtre que aprèn, el bloqueig d’un remitent i el sentit comú davant les estafes.',
      answer:
        'Marca com a correu brossa el que no vulguis (botó dret > Mou a Correu brossa) i el filtre anirà aprenent. Per no rebre mai més d’algú concret, fes servir “Bloqueja el contacte”. I si un correu et fa mala espina, pregunta-ho a l’assistent abans de prémer res.',
      steps: [
        {
          t: 'Marca el que sigui brossa',
          d: 'Botó dret sobre la fila de la llista > “Mou a Correu brossa”. El filtre aprèn del que marques tu.',
          screen: 'mail-menu',
          highlight: 'junk',
        },
        {
          t: 'Bloqueja els pesats',
          d: 'Al mateix menú del botó dret hi ha “Bloqueja el contacte”: els seus correus deixaran d’arribar-te a la safata.',
          screen: 'mail-menu',
          highlight: 'block',
        },
        {
          t: 'Passa una revisió',
          d: 'A les regles hi ha “Cerca correu brossa”: repassa el que tens i mou a la carpeta de brossa el que ho sembli.',
          screen: 'settings-rules',
          highlight: 'spam',
        },
        {
          t: 'Davant del dubte, pregunta-ho',
          d: '“Aquest correu sembla una estafa?”. L’assistent et dirà què hi veu de sospitós: pressa, enllaços estranys, remitent que no quadra.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'Cap banc ni cap administració et demanarà mai la contrasenya per correu. Si te la demanen, és fals.',
        'Els butlletins que sí que vas demanar es treuen millor amb l’enllaç de baixa del final del correu.',
        'Repassa la carpeta de correu brossa de tant en tant: de vegades hi cau alguna cosa bona.',
      ],
      faq: [
        {
          q: 'M’ha anat a brossa un correu que sí que volia',
          a: 'Torna’l a la safata d’entrada: el filtre també aprèn dels encerts que li corregeixes.',
        },
        {
          q: 'La publicitat que sí que vaig demanar també és brossa?',
          a: 'No exactament. Aquesta és més fàcil de treure amb el seu enllaç de baixa; el filtre te la pot apartar igualment si te’n canses.',
        },
      ],
    },
    es: {
      title: 'Quitarte la publicidad y el correo basura de encima',
      lead: 'Tres herramientas: el filtro que aprende, el bloqueo de un remitente y el sentido común ante las estafas.',
      answer:
        'Marca como correo basura lo que no quieras (botón derecho > Mover a Correo basura) y el filtro irá aprendiendo. Para no recibir nunca más de alguien concreto, usa “Bloquear contacto”. Y si un correo te da mala espina, pregúntaselo al asistente antes de pulsar nada.',
      steps: [
        {
          t: 'Marca lo que sea basura',
          d: 'Botón derecho sobre la fila de la lista > “Mover a Correo basura”. El filtro aprende de lo que marcas tú.',
          screen: 'mail-menu',
          highlight: 'junk',
        },
        {
          t: 'Bloquea a los pesados',
          d: 'En el mismo menú del botón derecho está “Bloquear contacto”: sus correos dejarán de llegarte a la bandeja.',
          screen: 'mail-menu',
          highlight: 'block',
        },
        {
          t: 'Pasa una revisión',
          d: 'En las reglas está “Buscar correo basura”: repasa lo que tienes y mueve a la carpeta de basura lo que lo parezca.',
          screen: 'settings-rules',
          highlight: 'spam',
        },
        {
          t: 'Ante la duda, pregúntalo',
          d: '“¿Este correo parece una estafa?”. El asistente te dirá qué ve de sospechoso: prisas, enlaces raros, remitente que no cuadra.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'Ningún banco ni ninguna administración te pedirá jamás la contraseña por correo. Si te la piden, es falso.',
        'Los boletines que sí pediste se quitan mejor con el enlace de baja del final del correo.',
        'Repasa la carpeta de correo basura de vez en cuando: a veces cae algo bueno.',
      ],
      faq: [
        {
          q: 'Se me ha ido a basura un correo que sí quería',
          a: 'Devuélvelo a la bandeja de entrada: el filtro también aprende de las correcciones.',
        },
        {
          q: '¿La publicidad que sí pedí también es basura?',
          a: 'No exactamente. Esa se quita mejor con su enlace de baja; el filtro puede apartártela igualmente si te cansas.',
        },
      ],
    },
    en: {
      title: 'Getting junk mail and ads off your back',
      lead: 'Three tools: a filter that learns, blocking a sender, and common sense about scams.',
      answer:
        'Mark what you do not want as junk (right-click > Move to Junk) and the filter learns. To never hear from someone again, use “Block contact”. And if an email feels off, ask the assistant before you click anything.',
      steps: [
        {
          t: 'Mark what is junk',
          d: 'Right-click the row in the list > “Move to Junk”. The filter learns from what you mark.',
          screen: 'mail-menu',
          highlight: 'junk',
        },
        {
          t: 'Block the persistent ones',
          d: 'The same right-click menu has “Block contact”: their emails stop reaching your inbox.',
          screen: 'mail-menu',
          highlight: 'block',
        },
        {
          t: 'Run a sweep',
          d: 'The rules screen has “Scan for spam”: it goes through what you have and moves the obvious junk to the junk folder.',
          screen: 'settings-rules',
          highlight: 'spam',
        },
        {
          t: 'When in doubt, ask',
          d: '“Does this email look like a scam?”. The assistant tells you what looks suspicious: urgency, odd links, a sender that does not add up.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'No bank or government body will ever ask for your password by email. If they do, it is fake.',
        'Newsletters you actually signed up for come off best via the unsubscribe link at the bottom.',
        'Look through the junk folder now and then: something good lands there occasionally.',
      ],
      faq: [
        {
          q: 'Something I wanted went to junk',
          a: 'Put it back in the inbox: the filter learns from your corrections too.',
        },
        {
          q: 'Are the ads I signed up for junk as well?',
          a: 'Not quite. Those come off best with their own unsubscribe link, though the filter can set them aside if you get tired of them.',
        },
      ],
    },
  },

  {
    slug: 'reminders-and-pins',
    id: 'reminders',
    category: 'inbox',
    icon: 'bell',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'recordatori', 'recordatorio', 'reminder', 'recuérdame', 'recorda’m', 'fijar arriba',
      'fixar', 'pin', 'archivar', 'arxivar', 'archive', 'silenciar', 'mute', 'marcar como no leído',
      'lo miro luego',
    ],
    ca: {
      title: 'Recordatoris, fixar, arxivar i silenciar',
      lead: 'Els quatre gestos per treure’t un correu del davant sense perdre’l.',
      answer:
        'Amb el botó dret sobre un correu de la llista tens: “Recorda-m’ho” (en 1 hora, demà o la setmana que ve), “Fixa a dalt” perquè no baixi, “Arxiva” per treure’l de la safata i “Silencia” per no rebre més avisos d’aquell fil.',
      steps: [
        {
          t: 'Fes botó dret sobre el correu',
          d: 'A la fila de la llista, no dins del text. S’obre el menú amb totes les opcions.',
          screen: 'mail-menu',
          highlight: 'menu',
        },
        {
          t: '“Recorda-m’ho” si l’has de mirar més tard',
          d: 'Tries d’aquí a una hora, demà o la setmana que ve. Tornarà a aparèixer quan toqui.',
          screen: 'mail-menu',
          highlight: 'remind',
        },
        {
          t: '“Fixa a dalt” si no el vols perdre de vista',
          d: 'Es queda al capdamunt de la llista encara que arribin correus nous.',
          screen: 'mail-menu',
          highlight: 'pin',
        },
        {
          t: '“Arxiva” quan ja està fet',
          d: 'Surt de la safata però no s’esborra: continua a la carpeta d’arxiu i es pot buscar.',
          screen: 'mail-menu',
          highlight: 'archive',
        },
        {
          t: '“Silencia” per als fils pesats',
          d: 'La conversa continua però deixa de donar-te la tabarra amb avisos.',
          screen: 'mail-menu',
          highlight: 'mute',
        },
      ],
      tips: [
        'També pots demanar-ho al xat: “recorda’m aquest correu la setmana que ve”.',
        '“Marca com a no llegit” és el truc de tota la vida per no oblidar-te’n.',
      ],
      faq: [
        {
          q: 'Arxivar és el mateix que esborrar?',
          a: 'No. Arxivar el treu de la safata i el desa; esborrar el porta a la paperera.',
        },
      ],
    },
    es: {
      title: 'Recordatorios, fijar, archivar y silenciar',
      lead: 'Los cuatro gestos para quitarte un correo de delante sin perderlo.',
      answer:
        'Con el botón derecho sobre un correo de la lista tienes: “Recordármelo” (en 1 hora, mañana o la semana que viene), “Fijar arriba” para que no baje, “Archivar” para sacarlo de la bandeja y “Silenciar” para no recibir más avisos de ese hilo.',
      steps: [
        {
          t: 'Haz botón derecho sobre el correo',
          d: 'En la fila de la lista, no dentro del texto. Se abre el menú con todas las opciones.',
          screen: 'mail-menu',
          highlight: 'menu',
        },
        {
          t: '“Recordármelo” si lo tienes que mirar más tarde',
          d: 'Eliges dentro de una hora, mañana o la semana que viene. Volverá a aparecer cuando toque.',
          screen: 'mail-menu',
          highlight: 'remind',
        },
        {
          t: '“Fijar arriba” si no lo quieres perder de vista',
          d: 'Se queda en lo alto de la lista aunque lleguen correos nuevos.',
          screen: 'mail-menu',
          highlight: 'pin',
        },
        {
          t: '“Archivar” cuando ya está hecho',
          d: 'Sale de la bandeja pero no se borra: sigue en la carpeta de archivo y se puede buscar.',
          screen: 'mail-menu',
          highlight: 'archive',
        },
        {
          t: '“Silenciar” para los hilos pesados',
          d: 'La conversación sigue pero deja de darte la lata con avisos.',
          screen: 'mail-menu',
          highlight: 'mute',
        },
      ],
      tips: [
        'También puedes pedirlo en el chat: “recuérdame este correo la semana que viene”.',
        '“Marcar como no leído” es el truco de toda la vida para no olvidarte.',
      ],
      faq: [
        {
          q: '¿Archivar es lo mismo que borrar?',
          a: 'No. Archivar lo saca de la bandeja y lo guarda; borrar lo lleva a la papelera.',
        },
      ],
    },
    en: {
      title: 'Reminders, pinning, archiving and muting',
      lead: 'The four moves for getting an email out of your way without losing it.',
      answer:
        'Right-click an email in the list and you get: “Remind me” (in 1 hour, tomorrow or next week), “Pin to top” so it does not sink, “Archive” to take it out of the inbox and “Mute” to stop alerts from that thread.',
      steps: [
        {
          t: 'Right-click the email',
          d: 'On the row in the list, not inside the text. The menu with all the options opens.',
          screen: 'mail-menu',
          highlight: 'menu',
        },
        {
          t: '“Remind me” if you have to look at it later',
          d: 'Choose in an hour, tomorrow, or next week. It comes back when the time comes.',
          screen: 'mail-menu',
          highlight: 'remind',
        },
        {
          t: '“Pin to top” if you must not lose sight of it',
          d: 'It stays at the top of the list even as new mail arrives.',
          screen: 'mail-menu',
          highlight: 'pin',
        },
        {
          t: '“Archive” once it is dealt with',
          d: 'It leaves the inbox but is not deleted: it stays in the archive folder and is searchable.',
          screen: 'mail-menu',
          highlight: 'archive',
        },
        {
          t: '“Mute” for noisy threads',
          d: 'The conversation carries on but stops pestering you with alerts.',
          screen: 'mail-menu',
          highlight: 'mute',
        },
      ],
      tips: [
        'You can also ask in the chat: “remind me about this email next week”.',
        '“Mark as unread” is still the oldest trick for not forgetting.',
      ],
      faq: [
        {
          q: 'Is archiving the same as deleting?',
          a: 'No. Archiving takes it out of the inbox and keeps it; deleting sends it to the trash.',
        },
      ],
    },
  },

  {
    slug: 'email-types',
    id: 'email-types',
    category: 'inbox',
    icon: 'tag',
    level: 'advanced',
    plan: 'free',
    minutes: 5,
    topics: [
      'tipus de correu', 'tipos de correo', 'email types', 'clasificar', 'classificar', 'extraer datos',
      'extreure dades', 'facturas', 'factures', 'pedidos', 'comandes', 'reservas', 'campos',
      'sacar el importe', 'organizar por tipo',
    ],
    ca: {
      title: 'Tipus de correu: que la app te’n tregui les dades',
      lead: 'Si cada setmana reps factures, comandes o reserves, ensenya-li què són i què n’has de treure.',
      answer:
        'A Configuració > Tipus de correu pots definir categories (Factura, Comanda, Reserva…) amb els camps que t’interessen (import, data, número). Nukli classifica els correus i n’extreu aquests valors, que després veus a la fitxa del correu.',
      steps: [
        {
          t: 'Obre els tipus de correu',
          d: 'Botó de la barra d’icones de l’esquerra, o Configuració > Tipus de correu.',
          screen: 'settings-types',
          highlight: 'rail',
        },
        {
          t: 'Crea un tipus',
          d: 'Nom (“Factura”), color i una descripció que expliqui quins correus hi entren. La descripció la llegeix la IA.',
          screen: 'type-editor',
          highlight: 'name',
        },
        {
          t: 'Digues quins camps vols',
          d: 'Import, número de factura, data de venciment, proveïdor. Per a cada camp pots afegir una pista perquè l’encerti, i dir si és text, número, data…',
          screen: 'type-editor',
          highlight: 'fields',
        },
        {
          t: 'Deixa que els detecti',
          d: 'Al correu obert hi ha el botó “Detecta”: assigna el tipus i omple els camps. També els pots corregir a mà.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Fes que s’assigni sol',
          d: 'A les regles pots posar l’acció “Assigna un tipus de correu”, i així els nous ja arriben classificats.',
        },
      ],
      tips: [
        'És per a gent que rep molts correus iguals. Si no és el teu cas, pots saltar-te aquesta guia sense pena.',
        'Els valors extrets es poden repassar i corregir sempre: no es toca el correu original.',
      ],
      faq: [
        {
          q: 'Cal saber programar?',
          a: 'No. Els camps es descriuen amb paraules normals (“import total de la factura”).',
        },
      ],
    },
    es: {
      title: 'Tipos de correo: que la app te saque los datos',
      lead: 'Si cada semana recibes facturas, pedidos o reservas, enséñale qué son y qué hay que sacar de ellos.',
      answer:
        'En Ajustes > Tipos de correo puedes definir categorías (Factura, Pedido, Reserva…) con los campos que te interesan (importe, fecha, número). Nukli clasifica los correos y extrae esos valores, que luego ves en la ficha del correo.',
      steps: [
        {
          t: 'Abre los tipos de correo',
          d: 'Botón de la barra de iconos de la izquierda, o Ajustes > Tipos de correo.',
          screen: 'settings-types',
          highlight: 'rail',
        },
        {
          t: 'Crea un tipo',
          d: 'Nombre (“Factura”), color y una descripción que explique qué correos entran ahí. La descripción la lee la IA.',
          screen: 'type-editor',
          highlight: 'name',
        },
        {
          t: 'Di qué campos quieres',
          d: 'Importe, número de factura, fecha de vencimiento, proveedor. Para cada campo puedes añadir una pista para que acierte, y decir si es texto, número, fecha…',
          screen: 'type-editor',
          highlight: 'fields',
        },
        {
          t: 'Deja que los detecte',
          d: 'En el correo abierto está el botón “Detectar”: asigna el tipo y rellena los campos. También los puedes corregir a mano.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Haz que se asigne solo',
          d: 'En las reglas puedes poner la acción “Asignar tipo de correo”, y así los nuevos ya llegan clasificados.',
        },
      ],
      tips: [
        'Es para quien recibe muchos correos iguales. Si no es tu caso, puedes saltarte esta guía sin pena.',
        'Los valores extraídos se pueden repasar y corregir siempre: no se toca el correo original.',
      ],
      faq: [
        {
          q: '¿Hay que saber programar?',
          a: 'No. Los campos se describen con palabras normales (“importe total de la factura”).',
        },
      ],
    },
    en: {
      title: 'Email types: letting the app pull out the data',
      lead: 'If invoices, orders or bookings arrive every week, teach it what they are and what to extract.',
      answer:
        'In Settings > Email types you can define categories (Invoice, Order, Booking…) with the fields you care about (amount, date, number). Nukli classifies the emails and extracts those values, which you then see on the email itself.',
      steps: [
        {
          t: 'Open email types',
          d: 'Button in the icon bar on the left, or Settings > Email types.',
          screen: 'settings-types',
          highlight: 'rail',
        },
        {
          t: 'Create a type',
          d: 'Name (“Invoice”), colour, and a description of which emails belong to it. The AI reads that description.',
          screen: 'type-editor',
          highlight: 'name',
        },
        {
          t: 'Say which fields you want',
          d: 'Amount, invoice number, due date, supplier. Each field can carry a hint so it gets them right, and a type: text, number, date…',
          screen: 'type-editor',
          highlight: 'fields',
        },
        {
          t: 'Let it detect them',
          d: 'The open email has a “Detect” button: it assigns the type and fills the fields. You can correct them by hand.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Make it automatic',
          d: 'In the rules you can use the “Assign email type” action, so new mail arrives already classified.',
        },
      ],
      tips: [
        'This is for people receiving many similar emails. If that is not you, skip this guide with a clear conscience.',
        'Extracted values can always be reviewed and corrected: the original email is never touched.',
      ],
      faq: [
        {
          q: 'Do I need to know how to program?',
          a: 'No. Fields are described in plain words (“total amount of the invoice”).',
        },
      ],
    },
  },
];
